<div class="video-grid-container" *ngIf="videos$ | async as videos">
  <h2 class="video-grid-title">{{ title }}</h2>
  <div class="videos-render">
    <ng-container *ngFor="let video of videos">
      <app-video-item [type]="type" [video]="video" [me]="me"></app-video-item>
    </ng-container>
  </div>
</div>
